/**
 * useApplicationDetail
 * Fetches application detail with user info from /backoffice/applications/{applicationId}
 */
import { useQuery } from '@tanstack/react-query';
import { getApplicationDetail } from '@/services/credit-engine.service';

export function useApplicationDetail(applicationId: string, directoryId: string) {
  const query = useQuery({
    queryKey: ['backoffice', 'applications', applicationId, directoryId],
    queryFn: () => getApplicationDetail(applicationId, directoryId),
    enabled: Boolean(applicationId && directoryId),
  });

  return {
    application: query.data?.data?.application ?? null,
    user: query.data?.data?.user ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
